import { useTranslate } from 'src/locales';
import { ReusableTable } from './table/ReusableTable';
import type { TableHeadCellProps } from 'src/components/table';
import { useMemo } from 'react';
import type { ICustomerProfile } from 'src/types/customers';
import { CustomersGridRow } from './table/CustomersGridRow';
import { useGetPaginatedCustomers } from './useGetPaginatedCustomers';

type Props = {
  clientId: string;
};

export function CustomersTab({ clientId }: Props) {
  const { currentLang, t } = useTranslate();

  const { data, totalItems, totalPages, isFetching, isLoading, page, filters, sorting, dispatch } =
    useGetPaginatedCustomers(clientId);

  const tableHeadColumns: TableHeadCellProps[] = useMemo(() => {
    return [
      { id: 'name', label: t('tables.columns.name'), width: '25%', dataTestId: 'th-name' },

      {
        id: 'countryCode',
        label: t('tables.columns.country'),
        width: '15%',
        dataTestId: 'th-country',
      },
      {
        id: 'totalRemainingBalance',
        label: t('tables.columns.trb'),
        align: 'right',
        width: '20%',
        dataTestId: 'th-total-remaining-balance',
      },
      {
        id: 'openInvoices',
        label: t('tables.columns.openInvoices'),
        align: 'center',
        width: '14%',
        dataTestId: 'th-open-invoices',
      },
    ];
  }, [currentLang]);

  return (
    <ReusableTable
      isLoading={isLoading}
      isFetching={isFetching}
      tableHeadColumns={tableHeadColumns}
      totalItems={totalItems}
      totalPages={totalPages}
      paginationPage={page}
      dispatch={dispatch}
      sorting={sorting}
      data={data.map((el) => {
        const obj = { ...el } as unknown as ICustomerProfile;
        delete (obj as any)['clientName'];
        delete (obj as any)['clientLogo'];

        return obj;
      })}
      customGridRow={({ row, index, table }) => (
        <CustomersGridRow
          rowIndex={index}
          key={row.id}
          row={row}
          selected={table.selected.includes(row.id)}
        />
      )}
    />
  );
}
